// Live product catalog for the admin dashboard.
// SLUG SOURCE OF TRUTH: m365dotnet src/Parslee.M365.Core/Models/EntitlementModels.cs AllKnownProducts.
// This is a DELIBERATE live-products SUBSET of that list — ink, hydra, acs, path are still in
// development and are intentionally omitted; add them here when they go live.
export const PRODUCT_CATALOG: Record<string, { name: string; description: string }> = {
  aie: { name: 'ButtonUp Core', description: 'M365 AI employee orchestration' },
  odi: { name: 'Document Intelligence (ODI)', description: 'Organizational document processing' },
  studio: { name: 'Agentic Studio', description: 'AI video production' },
  crm: { name: 'CRM', description: 'CRM integration' },
  salestrainer: { name: 'SalesTrainer', description: 'AI sales coaching & call scoring' },
};

export const getProductName = (productId: string): string =>
  PRODUCT_CATALOG[productId]?.name ?? productId;
